<template>
  <section>
    <!-- <LoadingOverlay :is-active="loading"> -->
    <div
      v-if="geometry"
      class="flex flex-col items-center justify-center -mt-12 text-center font-ff-good-pro-cond"
    >
      <div class="w-full overflow-x-auto">
        <table
          v-if="geometry.is_bike_sizes === 1"
          class="table w-full mt-8 text-xl text-center rounded-md font-ff-good-pro-cond bg-dark-gray-100 geometrydata md:text-2xl md:mt-12"
        >
          <tbody>
            <tr
              v-for="(bikeSizeRow, bikeSizeIndex) in geometry.bike_sizes"
              :key="bikeSizeIndex"
              :class="{
                ' opacity-10 translate-z border-b-2 rounded-md border-b-white':
                  bikeSizeIndex === 0,
              }"
              :data-aos-delay="5 * bikeSizeIndex"
              data-aos="fade"
              data-aos-once="true"
            >
              <th
                v-if="bikeSizeIndex === 0"
                v-for="(bikeRow, bikeRowFirstIndex) in bikeSizeRow"
                :key="bikeRowFirstIndex"
                class="px-3 md:px-[30px] py-2 text-lg font-bold text-left font-ff-good-pro-cond"
                v-text="
                  bikeSizeIndex > 0 && bikeRowIndex < 2
                    ? bikeRow
                      ? bikeRow
                      : ''
                    : bikeRow
                    ? bikeRow
                    : '-'
                "
              ></th>
              <td
                v-else
                v-for="(bikeRow, bikeRowIndex) in bikeSizeRow"
                :key="bikeRowIndex"
                class="px-3 md:px-[30px] py-2 text-lg font-normal rounded-md font-ff-good-pro-cond text-left"
                v-text="
                  bikeSizeIndex > 0 && bikeRowIndex < 2
                    ? bikeRow
                      ? bikeRow
                      : ''
                    : bikeRow
                    ? bikeRow
                    : '-'
                "
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p
        v-if="geometry.description"
        class="w-full px-[30px] py-3.5 text-left bg-dark-gray-100 mt-2 rounded-md"
      >
        {{ geometry.description }}
      </p>
      <img v-if="geometry.image" :src="geometry.image" class="max-w-[70%]" />
      <div class="w-full overflow-x-auto">
        <table
          v-if="geometry.is_sizes === 1"
          class="table w-full mt-12 text-center rounded-md font-ff-good-pro-cond bg-dark-gray-100"
        >
          <tbody>
            <tr
              v-for="(sizeRow, sizeIndex) in geometry.sizes"
              :key="sizeIndex"
              :class="{
                ' opacity-10 translate-z border-b-2 rounded-md border-b-white':
                  sizeIndex === 0,
              }"
              :data-aos-delay="5 * sizeIndex"
              data-aos="fade"
              data-aos-once="true"
            >
              <th
                v-if="sizeIndex === 0"
                v-for="(size, sizeRow2Index) in sizeRow"
                :key="sizeRow2Index"
                v-text="
                  sizeIndex > 0 && sizeRowIndex < 2
                    ? size
                      ? size
                      : ''
                    : size
                    ? size
                    : '-'
                "
                class="px-3 md:px-[30px] py-2 text-lg font-bold text-left font-ff-good-pro-cond"
              ></th>
              <td
                v-else
                v-for="(size, sizeRowIndex) in sizeRow"
                :key="sizeRowIndex"
                v-text="
                  sizeIndex > 0 && sizeRowIndex < 2
                    ? size
                      ? size
                      : ''
                    : size
                    ? size
                    : '-'
                "
                class="px-3 md:px-[30px] py-2 text-lg font-normal rounded-md font-ff-good-pro-cond text-left"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else-if="!loading" class="text-center">
      <WarningsNotFound />
    </div>
    <div v-else class="h-20" />
    <!-- </LoadingOverlay> -->
  </section>
</template>

<script setup>
import { useProductMenuStore } from "~/store/productmenu";

const props = defineProps({
  geometry: {
    type: [Object, null],
    required: true,
  },
});

const productMenuStore = useProductMenuStore();

const loading = ref(false);

onMounted(() => {
  if (props.geometry && Object.keys(props.geometry).length > 0) {
    productMenuStore.statusGeometries(true);
  }
});
</script>

<style lang="postcss">
.geometrydata {
  tr:not(:first-child):hover {
    td {
      @apply bg-black bg-opacity-5;
    }
  }
  .separator td:not(:first-child) {
    @apply border-b border-b-gray-200;
  }
  td:nth-child(1) {
    @apply font-bold font-ff-good-pro-cond;
  }
  td:nth-child(2) {
    @apply text-left;
  }
}
</style>
